import {
  AlertCircleIcon,
  ArrowRight03Icon,
  Cancel01Icon,
  Loading03Icon,
  Tick02Icon
} from "@hugeicons-pro/core-stroke-rounded";
import { BadgeVariant } from "shared/components";
import type { PrescreeningResult } from "api/lead";

type PrescreeningResultConfig = {
  label: string;
  variant: BadgeVariant;
  className: string;
  icon: typeof Tick02Icon;
};

export const PRESCREENING_RESULT_CONFIG: Record<
  PrescreeningResult,
  PrescreeningResultConfig
> = {
  failed: {
    label: "Failed",
    variant: BadgeVariant.ERROR,
    className: "!text-danger-700",
    icon: Cancel01Icon
  },
  needs_review: {
    label: "Needs review",
    variant: BadgeVariant.WARNING,
    className: "!text-warning-800",
    icon: AlertCircleIcon
  },
  abandoned: {
    label: "Abandoned",
    variant: BadgeVariant.WARNING,
    className: "!text-warning-800",
    icon: ArrowRight03Icon
  },
  in_progress: {
    label: "In progress",
    variant: BadgeVariant.WARNING,
    className: "!text-warning-800",
    icon: Loading03Icon
  },
  submitted: {
    label: "Submitted",
    variant: BadgeVariant.BASE,
    className: "",
    icon: Tick02Icon
  },
  passed: {
    label: "Passed",
    variant: BadgeVariant.SUCCESS,
    className: "!text-success-800",
    icon: Tick02Icon
  },
  not_started: {
    label: "Not started",
    variant: BadgeVariant.BASE,
    className: "",
    icon: Tick02Icon
  }
};

export const PRESCREENING_RESULT_FILTER_LABEL: Record<
  PrescreeningResult,
  string
> = {
  failed: "Failed",
  needs_review: "Needs review",
  abandoned: "Abandoned",
  in_progress: "In progress",
  submitted: "Submitted",
  passed: "Passed",
  not_started: "Not started"
};

export const PRESCREENING_RESULT_FILTER_OPTIONS: {
  id: PrescreeningResult;
  name: string;
}[] = (
  [
    "failed",
    "needs_review",
    "abandoned",
    "in_progress",
    "submitted",
    "passed",
    "not_started"
  ] as PrescreeningResult[]
).map((id) => ({ id, name: PRESCREENING_RESULT_FILTER_LABEL[id] }));

export const PRESCREENING_PILL_RESULTS: PrescreeningResult[] = [
  "failed",
  "needs_review"
];

export const PRESCREENING_PILL_LABEL: Partial<
  Record<PrescreeningResult, string>
> = {
  failed: "Failed prescreening",
  needs_review: "Needs review"
};

const PRESCREENING_RESULTS: PrescreeningResult[] = [
  "failed",
  "needs_review",
  "abandoned",
  "in_progress",
  "submitted",
  "passed",
  "not_started"
];

export const isPrescreeningResult = (
  value: unknown
): value is PrescreeningResult =>
  typeof value === "string" &&
  PRESCREENING_RESULTS.includes(value as PrescreeningResult);
